const state = {
  windowWidth: null, //used to access screen size changes in all component
  isMobileWindowSize: false, //to check mobile view window size
  darkMode: false, //enable Theme
  currentUser: "", //current logged in user firebase object
  userIpAddress: "", // user Ip address
  logoutInProgress: false, //logout in flight, drives full-page loader
  isProxyUser: false, //to track if current user is a proxy user (impersonated)
  modalOpened: false,
  currentTab: "", // current selected tab in AppTopBar component
  isProduction: parseInt(localStorage.getItem("isProduction"), 10),
  apiTimeOut: 29000,
  formAccessRights: null, //Access rights for all forms
  formIdAccessRights: null,
  sideBarMenuList: [], //sidebar menu list
  isAdmin: 0, //to check user is an admin or not
  isManager: 0, //to check user is an manager or not
  // organization details all in single object
  orgDetails: {
    organizationName: "",
    orgDateFormat: "YYYY/MM/DD", //by default we have this format.Change based on org format
    assessmentYear: "", // assessment year of the organization
    paycycle: "",
    employeeId: 0, // employee id of the login user
    assetManagementRedirectionUrl: "",
  },
  userDetails: {
    employeeId: null,
    userDefinedEmployeeId: "",
    employeeFullName: "",
    employeeFirstName: "",
    employeePhotoPath: "",
    employeeEmail: "",
    locationTimeZone: "Asia/Kolkata",
  },
  payrollUrl: null,
  //employees search and filter form data
  empSearchValue: "",
  empFilterValue: {
    selectedDepartment: [],
    selectedDesignation: [],
    selectedEmpType: [],
    selectedLocation: [],
    selectedWorkSchedule: [],
  },
  //to check whether we are sending email of team activity tracker

  isSendEmailButtonClicked: false,

  // request access notification bar data
  showRequestAccessNotification: false,
  //regime top notification bar data
  showTaxRegimeSelection: false,
  regimeComparisonDetails: {},
  showTaxComparisonModal: false,

  //snackbar data
  showSnackbar: false,
  snackBarMessage: "",
  snackBarType: "warning",
  snackBarTimeout: 5000,

  //browser support webp
  isWebpSupport: false,

  // perfect-scrollbar settings with wheel propagation to avoid external scrolling
  scrollbarWithWheelPropagationSettings: {
    maxScrollbarLength: 60,
    wheelSpeed: 0.6,
    wheelPropagation: false,
  },
  // perfect-scrollbar settings without wheelPropagation
  scrollbarSettings: {
    maxScrollbarLength: 60,
    wheelSpeed: 0.6,
  },
  // perfect-scrollbar settings without wheelPropagation
  smallScrollbarSettings: {
    maxScrollbarLength: 30,
    wheelSpeed: 0.6,
  },
  // dashboard type chosen in plan
  planDashboardType: "",
  clearTopBarSearch: false,
  //vue forms list hard coded to route vue forms differently
  vue3Forms: [
    { formId: 15, formName: "Job Posts" },
    { formId: 16, formName: "Job Candidates" },
    { formId: 18, formName: "My Profile" },
    { formId: 23, formName: "Timesheets" },
    { formId: 34, formName: "Exit Management" },
    { formId: 52, formName: "Provident Fund" },
    { formId: 126, formName: "NPS" },
    { formId: 140, formName: "Compensatory Off Balance" },
    { formId: 173, formName: "Workflow Builder" },
    { formId: 178, formName: "Individuals" },
    { formId: 182, formName: "Interview Rounds Master" },
    { formId: 184, formName: "Approval Management" },
    { formId: 187, formName: "Organization Chart" },
    { formId: 188, formName: "Dynamic Form Builder" },
    { formId: 195, formName: "Tax and Statutory Compliance" },
    { formId: 201, formName: "General" },
    { formId: 205, formName: "Payroll" },
    { formId: 239, formName: "Full & Final Settlement" },
    { formId: 240, formName: "Pre Approvals" },
    { formId: 241, formName: "Integration" },
    { formId: 243, formName: "Team Summary" },
    { formId: 247, formName: "Pre Approval" },
    { formId: 252, formName: "LOP Recovery" },
    { formId: 256, formName: "LOP Recovery" },
    { formId: 257, formName: "Pre Approval" },
    { formId: 262, formName: "Timesheets" },
    { formId: 264, formName: "Compensatory Off Balance" },
    { formId: 276, formName: "Time Off Management" },
    { formId: 281, formName: "Recruitment" },
    { formId: 283, formName: "Org Structure" },
    { formId: 285, formName: "Settings" },
    { formId: 287, formName: "Hiring Forecast" },
    { formId: 288, formName: "Table of Organization" },
    { formId: 289, formName: "Job Requisition" },
    { formId: 295, formName: "Location Intelligence" },
    { formId: 303, formName: "Key Logger" },
    { formId: 304, formName: "Attendance" },
    { formId: 305, formName: "Attendance" },
    { formId: 306, formName: "Shift Swap" },
    { formId: 308, formName: "My Integration" },
    { formId: 318, formName: "Salary Info" },
    { formId: 325, formName: "Recruitment Dashboard" },
    { formId: 330, formName: "Time Off" },
    { formId: 331, formName: "Time Off" },
    { formId: 336, formName: "Payroll Management" },
    { formId: 340, formName: "Travel and Expenses" },
    { formId: 343, formName: "Travel and Expenses" },
    { formId: 344, formName: "My Pay" },
    { formId: 105, formName: "Tax Configuration" },
    { formId: 377, formName: "Statutory Components" },
    { formId: 386, formName: "Toxicity Intelligence" },
    { formId: 387, formName: "My Declarations" },
    { formId: 399, formName: "Benefits and Deduction" },
    { formId: 400, formName: "Benefits and Deduction - Settings" },
    { formId: 420, formName: "Settings" },
    { formId: 421, formName: "Process Builder" },
    { formId: 422, formName: "Pulseflow" }, // My Team
    { formId: 423, formName: "Salary Payslip" },
    { formId: 424, formName: "Pulseflow" }, // Employee Self Service
    { formId: 428, formName: "Help Desk" }, // HRMS
    { formId: 429, formName: "Help Desk" }, // Admin
    { formId: 432, formName: "Compliance Management" }, // Core HR
    { formId: 434, formName: "My Compliance" }, // Employee Self Service
    { formId: 437, formName: "Tasks" },
    { formId: 439, formName: "DocuSignV2" }, // Compliance Management
    { formId: 446, formName: "Declarations" },
    { formId: 442, formName: "Live View" },
    { formId: 443, formName: "LiveDesk" },
    { formId: 450, formName: "My Tax" },
    { formId: 455, formName: "My Roster" },
    { formId: 461, formName: "Alumni Portal" },
    { formId: 466, formName: "Onboarding" }, // Settings -> Onboarding
    { formId: 469, formName: "DocuSign" },
    { formId: 492, formName: "Task Flow Builder" }, // Workflow
    { formId: 514, formName: "Reconciliation" },
    { formId: 497, formName: "Performance Settings" },
    { formId: 500, formName: "KRAs and Goals" },
    { formId: 504, formName: "Performance Appraisal" },
  ],
  vue2Forms: [
    "Productivity Monitoring",
    "Activity Tracker",
    "Members",
    "Reports",
    "Shift Scheduling",
    "Salary Template",
    "Additional Wage Claim",
    "Activity Dashboard",
    "Assets",
    "Performance Management",
    "Billing",
    "ESOP",
    "Workforce Analytics",
    "Register Face",
    "Core HR",
    "File Transfers",
    "Data Loss Prevention",
    "Vendors",
    "Accreditation",
    "Employee Data Management",
    "Performance Evaluation",
  ],
  // order should be based on tab order
  employeeDataSetupForms: [
    {
      formName: "custom-employee-groups",
      displayFormName: "Custom Group", // fallback name
      url: "custom-employee-groups",
      isVue2: true,
      formId: 180,
    },
    {
      formName: "projects",
      displayFormName: "Projects", // fallback name
      url: "projects",
      isVue2: false,
      formId: 3,
    },
    {
      formName: "holidays",
      displayFormName: "Holidays", // fallback name
      url: "holidays",
      isVue2: true,
      formId: 8,
    },
    {
      formName: "user-accounts",
      displayFormName: "User Accounts", // fallback name
      url: "user-accounts",
      isVue2: true,
      formId: 238,
    },
    {
      formName: "document-sub-type",
      displayFormName: "Document Subtype", // fallback name
      url: "document-subtype",
      isVue2: false,
      formId: 177,
    },
    {
      formName: "accreditation-category-and-type",
      displayFormName: "Accreditation Category and Type", // fallback name
      url: "accreditation-category-and-type",
      isVue2: false,
      formId: 351,
    },
    {
      formName: "register-face",
      displayFormName: "Register Face", // fallback name
      url: "register-face",
      isVue2: true,
      formId: 226,
    },
    {
      formName: "help-desk-category",
      displayFormName: "Help Desk Category", // fallback name
      url: "employee-data-management/help-desk-category",
      isVue2: false,
      formId: 431,
    },
    {
      formName: "id-card-templates",
      displayFormName: "ID Card Templates", // fallback name
      url: "employee-data-management/id-card-templates",
      isVue2: false,
      formId: 491,
    },
  ],
  coreHrOrgStructureForms: [
    {
      formName: "employee-type",
      displayFormName: "employeeType",
      url: "employee-type",
      isVue2: false,
      formId: 27,
    },
    {
      formName: "grades",
      displayFormName: "grades",
      url: "grades",
      isVue2: false,
      formId: 20,
    },
    {
      formName: "locations",
      displayFormName: "locations",
      url: "locations",
      isVue2: false,
      formId: 1,
    },
    {
      formName: "department-hierarchy",
      displayFormName: "departmentHierarchy",
      url: "department-hierarchy",
      isVue2: false,
      formId: 2,
    },
    {
      formName: "designations/positions",
      displayFormName: "designationsPositions",
      url: "designations",
      isVue2: true,
      formId: 237,
    },
    {
      formName: "job-roles",
      displayFormName: "jobRoles",
      url: "job-roles",
      isVue2: false,
      formId: 329,
    },
    {
      formName: "work-schedule",
      displayFormName: "workSchedule",
      url: "work-schedule",
      isVue2: true,
      formId: 221,
    },
    {
      formName: "business-unit-/-cost-center",
      displayFormName: "businessUnitCostCenter",
      url: "business-unit",
      isVue2: false,
      formId: 251,
    },
    {
      formName: "organization-group",
      displayFormName: "organizationGroup",
      url: "organization-group",
      isVue2: false,
      formId: 269,
    },
    {
      formName: "location-type",
      displayFormName: "locationType",
      url: "location-type",
      isVue2: false,
      formId: 410,
    },
    {
      formName: "location-area",
      displayFormName: "locationArea",
      url: "location-area",
      isVue2: false,
      formId: 411,
    },
    {
      formName: "brand",
      displayFormName: "brand",
      url: "brand",
      isVue2: false,
      formId: 412,
    },
    {
      formName: "job-levels",
      displayFormName: "jobLevels",
      url: "job-levels",
      isVue2: false,
      formId: 414,
    },
    {
      formName: "position-details",
      displayFormName: "positionDetails",
      url: "position-details",
      isVue2: false,
      formId: 430,
    },
    {
      formName: "client",
      displayFormName: "client",
      url: "client",
      isVue2: false,
      formId: 486,
    },
  ],
  adminForms: [
    "Admin",
    "Employee Admin",
    "Payroll Admin",
    "Service Provider Admin",
    "Productivity Monitoring Admin",
  ],
  coreHrSettingsForms: [
    {
      formName: "general",
      formId: "413",
      displayFormName: "General",
      url: "general",
      isVue2: false,
    },
    {
      formName: "leave",
      displayFormName: "Time Off",
      url: "time-off",
      isVue2: true,
      subForms: ["short-time-off-(permission)", "short-time-off-(on-duty)"],
    },
    {
      formName: "comp-off",
      displayFormName: "Comp Off",
      url: "comp-off",
      formId: [250, 346],
      isVue2: false,
    },
    {
      formName: "special-wages",
      displayFormName: "Special Wages",
      url: "special-wages",
      isVue2: false,
    },
    {
      formName: "over-time",
      displayFormName: "Overtime",
      url: "overtime",
      isVue2: false,
    },
    {
      formName: "employee-number-series",
      displayFormName: "Employee Number Series",
      url: "employee-number-series",
      isVue2: false,
    },
    {
      formName: "attendance-configuration",
      displayFormName: "Attendance Configuration",
      url: "attendance-configuration",
      isVue2: false,
    },
    {
      formName: "geo-fencing-&-selfie-attendance",
      displayFormName: "Geo-Fencing & Selfie Attendance",
      url: "geo-fencing-&-selfie-attendance",
      isVue2: true,
    },
    {
      formName: "holidays",
      displayFormName: "Holidays",
      url: "holidays",
      isVue2: true,
    },
    {
      formName: "pre-approvals",
      displayFormName: "Pre Approvals",
      url: "pre-approvals",
      isVue2: false,
    },
    {
      formName: "lop-recovery",
      formId: "253",
      displayFormName: "LOP Recovery",
      url: "lop-recovery",
      isVue2: false,
    },
    {
      formName: "probation-period",
      formId: "416",
      displayFormName: "Probation Period",
      url: "probation-period",
      isVue2: false,
    },
    {
      formName: "notice-period",
      formId: "417",
      displayFormName: "Notice Period",
      url: "notice-period",
      isVue2: false,
    },
    {
      formName: "attendance-policy",
      formId: "425",
      displayFormName: "Attendance Policy",
      url: "attendance-policy",
      isVue2: false,
    },
    {
      formName: "alumni-portal-config",
      formId: "461",
      displayFormName: "Alumni Portal",
      url: "alumni-portal-config",
      isVue2: false,
    },
    {
      formName: "super-admin",
      formId: "147",
      displayFormName: "Roles",
      url: "roles",
      isVue2: false,
      accessType: "optionalChoice",
    },
    {
      formName: "project-settings",
      formId: "268",
      displayFormName: "Project",
      url: "project",
      isVue2: false,
    },
  ],
  rosterManagementForm: [
    {
      formName: "shift-scheduling",
      displayFormName: "Shift Scheduling",
      url: "shift-scheduling",
      isVue2: true,
    },
    {
      formName: "shift-rotation",
      displayFormName: "Shift Rotation",
      url: "shift-rotation",
      isVue2: false,
    },
  ],
  dataLossPreventionForm: [
    {
      formName: "dataLossPrevention",
      displayFormName: "dataLossPrevention",
      formId: 230,
      url: "data-loss-prevention",
      isVue2: true,
    },
    {
      formName: "internetAccessControl",
      displayFormName: "internetAccessControl",
      formId: 265,
      url: "data-loss-prevention/internet-access-control",
      isVue2: false,
    },
    {
      formName: "locationTracking",
      displayFormName: "locationTracking",
      formId: 284,
      url: "data-loss-prevention/location-tracking",
      isVue2: false,
    },
    {
      formName: "keyLogging",
      displayFormName: "keyLogging",
      formId: 299,
      url: "data-loss-prevention/key-logging",
      isVue2: false,
    },
    {
      formName: "additionalScreenshots",
      displayFormName: "additionalScreenshots",
      formId: 300,
      url: "data-loss-prevention/additional-screenshots",
      isVue2: false,
    },
    {
      formName: "customAlert",
      displayFormName: "customAlert",
      formId: 385,
      url: "data-loss-prevention/custom-alert",
      isVue2: false,
      translationKey: "customAlert",
    },
    {
      formName: "toxicityIdentifier",
      displayFormName: "toxicityIdentifier",
      formId: 384,
      url: "data-loss-prevention/toxicity-identifier",
      isVue2: false,
    },
    {
      formName: "auditLog",
      displayFormName: "auditLog",
      formId: 376,
      url: "data-loss-prevention/audit-log",
      isVue2: false,
    },
  ],
  LiveDesk: [
    {
      formName: "Live View",
      displayFormName: "Live View",
      url: "livedesk/live-view",
      formId: 442,
      isVue2: false,
    },
    {
      formName: "LiveDesk",
      displayFormName: "Live Desk",
      url: "settings/livedesk",
      formId: 443,
      isVue2: false,
    },
  ],
  partnerForms: ["Trulead"],
  // billing/payment/subscription/plan
  trialPeriod: null, // pending days of trial period
  planSubscriptionStatus: "", // it maybe none, skipSub, or subscribed
  isAutoBilling: null, // in default it was set null, after retrieving the value may be 0 or 1
  chargeBeeSiteName: "", // chargebee site names based on staging or production environment
  autoBillingPlanCurrentStatus: "", // it defines the current status of the plan
  // auto-billing plan details
  autoBillingDetails: {
    planId: "",
    subscriptionId: "",
    subscribedPlanQuantity: 0,
    subscriptionCurrency: "",
    subscriptionBillingPeriod: 0,
  },
  isIntroScreenPresented: false,
  countryList: [],
  coordinates: {},
  enableWorkflow: "No",
  //Vendor Filters
  vendorAdminFilter: {
    selectedVendorType: [],
    selectedStatusLevel: [],
    selectedServiceOffered: [],
    selectedIndustryType: [],
    selectedServicePriority: [],
    selectedStatus: [],
  },
  customFormFields: [],
  projectLabel: "Project",
};
export default state;
